<template>
  <enterprises-table api-u-r-l="/api/enterprises" />
</template>

<script>
  import EnterprisesTable from '~/components/EnterprisesTable';

  export default {
    middleware: 'auth',
    components: {
      EnterprisesTable,
    },
  };
</script>
